import { logWrapper } from '../utils';

export default {
  revisionHistoryModel: [
    'runtimeConstant',
    '$q',
    '$http',
    '$sce',
    'webApiSettings',
    'EXT_ICONS',
    function (runtimeConstant, $q, $http, $sce, webApiSettings, EXT_ICONS) {
      function RevisionHistory(data) {
        if (!data) {
          return;
        }
        this.id = data.Id;
        this.idRevision = data.IdRevision;
        this.idAuthor = data.IdAuthor;
        this.idCompany = data.IdCompany;
        this.idDocumentType = data.IdDocumentType;
        this.idFolder = data.IdFolder;
        this.idStatus = data.IdStatus;
        this.revisionStatus = data.RevisionStatus ? data.RevisionStatus : 1;

        this.code = data.Code;
        this.title = data.Title;
        this.description = data.Description;
        this.revisionNumber =
          data.RevisionNumber !== undefined ? data.RevisionNumber : 0;
        this.date = data.Date;
        this.documentDate = data.DocumentDate;
        this.keywords = data.Keywords;
        this.extension = data.Extension;

        if (data.NextRevisionDate) {
          this.nextRevisionDate = new Date(Date.parse(data.NextRevisionDate));
        }

        if (data.NotificationDays) {
          this.notificationDays = data.NotificationDays;
        }

        this.size = data.Size;

        this.isFavorite = data.IsFavorite;
        this.isPublic = data.IsPublic;
        this.isSigned = data.IsSigned;

        this.numberOfPages = data.PageCount;
        this.propertiesIndexed = data.PropertiesIndexed;
        this.contentIndexed = data.ContentIndexed;
        this.features = data.Features;

        this.highlightFields = data.HighlightFields;

        this.additionalFields = data.AdditionalFields;
        this.author = data.Author;
        this.folder = data.Folder;
        this.documentType = data.DocumentType;
      }

      function getLargeIcon() {
        var ext = this.extension;
        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/large/default.png" width="32px"></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          image =
            '<img src="/assets/images/file_extensions/large/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/large/default.png\';" width="32px"></img>';
        }
        if (this.isSigned) {
          image +=
            '<img class="large_signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function view() {
        var url =
          '#/view/' + this.id + '/' + this.extension + '?w=false&o=true';
        window.open(url, '_blank');
      }

      function _download(documentId) {
        var deferred = $q.defer();

        var webApiMethod = 'revisions/file/generate/';

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              webApiMethod +
              documentId +
              '/old'
          )
          .then(
            function (result) {
              var data = result.data;
              var queryChar = data.indexOf('?') > -1 ? '&' : '?';
              top.location.href =
                webApiSettings.apiServiceBaseUri +
                'revisions/file/hash/' +
                data +
                queryChar +
                'download=true';
              deferred.resolve(true);
            },
            function (data) {
              deferred.reject(data);
            }
          );

        return deferred.promise;
      }

      function download() {
        _download(this.id).then(
          function () {},
          function () {}
        );
      }

      function run() {
        try {
          RevisionHistory.prototype = {
            getLargeIcon: logWrapper(
              getLargeIcon,
              runtimeConstant.isDebugModelsInternals
            ),
            view: logWrapper(view, runtimeConstant.isDebugModelsInternals),
            download: logWrapper(
              download,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return RevisionHistory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
